import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

/**
 * SortableTableHeader - A clickable table header with sort indicators
 * 
 * @param {Object} props
 * @param {string} props.column - The column key for sorting
 * @param {string} props.label - Display label for the header
 * @param {string} props.sortColumn - Currently sorted column
 * @param {string} props.sortDirection - Current sort direction ('asc' | 'desc' | null)
 * @param {Function} props.onSort - Callback when header is clicked
 * @param {string} props.align - Text alignment ('left' | 'right' | 'center'), default: 'left'
 * @param {string} props.className - Additional CSS classes
 */
const SortableTableHeader = ({
  column,
  label,
  sortColumn,
  sortDirection,
  onSort,
  align = 'left',
  className = ''
}) => {
  const isActive = sortColumn === column;
  
  // Determine aria-sort value
  const ariaSort = isActive 
    ? (sortDirection === 'asc' ? 'ascending' : 'descending')
    : 'none';

  // Alignment classes
  const alignClass = align === 'right' 
    ? 'text-right justify-end' 
    : align === 'center' 
      ? 'text-center justify-center' 
      : 'text-left justify-start';

  return (
    <th
      className={`py-3 px-4 text-sm font-medium text-muted-foreground select-none ${className}`}
      aria-sort={ariaSort}
    >
      <button
        type="button"
        onClick={() => onSort(column)}
        className={`inline-flex items-center gap-1 hover:text-foreground transition-colors w-full ${alignClass}`}
      >
        <span>{label}</span>
        <span className="flex-shrink-0 ml-1">
          {isActive ? (
            sortDirection === 'asc' ? (
              <ArrowUp className="h-3.5 w-3.5" />
            ) : (
              <ArrowDown className="h-3.5 w-3.5" />
            )
          ) : (
            <ArrowUpDown className="h-3.5 w-3.5 opacity-40" />
          )}
        </span>
      </button>
    </th>
  );
};

export default SortableTableHeader;
